<template>
  <div id="map-container">
    <div id="map">
    </div>
    <!-- <button v-if="detailView" class="btn-map" @click.prevent="showAverages()">Toon gemiddeldes</button> -->
    <div id="legend">
      <div class="color-bar"></div>
      <div class="numbers">
        <div>1</div>
        <div>2</div>
        <div>3</div>
      </div>
      <div class="labels">
        <div class="label green">1. Rustig</div>
        <div class="label yellow">2. Gezellig</div>
        <div class="label red">3. Druk</div>
      </div>
    </div>
  </div>

</template>

<script>
import { eventBus } from '@/event-bus.js'

var cityParam = null

export default {
  data () {
    return {
      map: null,
      markers: [],
      detailView: false,
      overviewBounds: null,
      activeCity: null,
      firstZoom: true,
      heatmapInitiated: false
    }
  },
  created () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const city = urlParams.get('city')
    if (city) {
      cityParam = city
    }
  },
  mounted () {
    this.activeCity = cityParam

    // use your own key...
    var app = this
    eventBus.$on('googleLoaded', () => {
      this.initMap()
    })
    eventBus.$on('sendCityData', (payload) => {
      this.renderCityMap(payload)
    })
    eventBus.$on('initHeatmap', (payload) => {
      // console.log('heatmap payload', payload)
      // payload.setMap(this.map)
      payload.forEach((city, i) => {
        city.data.devices.forEach((feed, i) => {
          if (feed.g_circle) {
            feed.g_circle.setMap(this.map)
            window.google.maps.event.addListener(feed.g_circle, 'click', function () {
              feed.g_info.open(this.map)
            })
          }
        })
      })

      this.heatmapInitiated = true

      eventBus.$emit('zoomChanged', app.map.getZoom())

      if (app.map.getZoom() >= 12 && !this.detailView) {
        eventBus.$emit('detailview', true)
        this.detailView = true
      }
      if (app.map.getZoom() <= 11 && this.detailView) {
        eventBus.$emit('detailview', false)
        this.detailView = false
      }
    })
    eventBus.$on('userpositionknown', (payload) => {
      // this.overviewBounds.extend(new window.google.maps.LatLng(payload.latitude, payload.longitude)) // User lat:lng
      var userLatLng = new window.google.maps.LatLng(payload.latitude, payload.longitude)
      var marker = new window.google.maps.Marker({
        position: userLatLng,
        title: 'Uw locatie',
        draggable: false,
        map: app.map
      })

      // Push marker to array
      this.markers.push(marker)

      // this.map.fitBounds(this.overviewBounds, 20)
    })
  },
  methods: {
    initMap: function () {
      var app = this
      this.map = new window.google.maps.Map(document.getElementById('map'), {
        // center: {
        //   lat: 51.2141191,
        //   lng: 3.0517553
        // },
        // zoom: 10,
        fullscreenControl: false,
        streetViewControl: false
      })
      window.google.maps.event.addListenerOnce(this.map, 'idle', function () {
        // do something only the first time the map is loaded
        eventBus.$emit('mapLoaded')
      })

      // if (!cityParam) {
      //   this.overviewBounds = new window.google.maps.LatLngBounds()
      //   this.overviewBounds.extend(new window.google.maps.LatLng(51.33411851176779, 3.3852946164181352)) // Knokke-Heist outer lat:lng
      //   this.overviewBounds.extend(new window.google.maps.LatLng(51.33812285270021, 3.218274262630625)) // De Panne outer lat:lng
      //   this.map.fitBounds(this.overviewBounds, 20)
      // } else {
      //   this.overviewBounds = new window.google.maps.LatLngBounds()
      // }

      this.overviewBounds = new window.google.maps.LatLngBounds()

      window.google.maps.event.addListener(this.map, 'zoom_changed', () => {
        if (this.heatmapInitiated) {
          eventBus.$emit('zoomChanged', app.map.getZoom())

          if (app.map.getZoom() >= 12 && !this.detailView) {
            eventBus.$emit('detailview', true)
            this.detailView = true
          }
          if (app.map.getZoom() <= 11 && this.detailView) {
            eventBus.$emit('detailview', false)
            this.detailView = false
          }
        }

        // if (!this.firstZoom) {
        //   if (app.map.getZoom() === 12) {
        //     eventBus.$emit('detailview', true)
        //   } else if (app.map.getZoom() === 11) {
        //     eventBus.$emit('detailview', false)
        //   }
        // }
      })
    },
    renderCityMap: function (cityData) {
      var app = this

      cityData.mapData.setMap(this.map)

      // and pass clicks on to the underlying map
      // cityData.mapData.addListener('click', (event) => {
      //   // this.detailView = true
      //   // eventBus.$emit('detailview', true)
      //   const bounds = new window.google.maps.LatLngBounds()
      //
      //   event.feature.getGeometry().forEachLatLng(function (latlng) {
      //     bounds.extend(latlng)
      //   })
      //
      //   this.map.fitBounds(bounds, 20)
      // })
      // cityData.mapData.addListener('addfeature', function (event) {
      //   console.log('feature added')
      // })
      cityData.mapData.addListener('mouseover', function (event) {
        eventBus.$emit('mouseoverCity', cityData.index)
      })

      cityData.mapData.addListener('mouseout', function () {
        eventBus.$emit('mouseoutCity', cityData.index)
      })

      cityData.mapData.getFeatureById('city').getGeometry().forEachLatLng(function (latlng) {
        app.overviewBounds.extend(latlng)
      })

      this.map.fitBounds(this.overviewBounds, 0)
    },
    // showAllCities: function () {
    //   this.map.fitBounds(this.overviewBounds)
    // },
    showAverages: function () {
      // this.map.data.forEach(function (feature) {
      //   console.log('in')
      //   this.processPoints(feature.getGeometry(), this.overviewBounds.extend, this.overviewBounds)
      // })
      // var latLng = new window.google.maps.LatLng(51.2141191, 2.8517553)
      // console.log('latlng', latLng)
      // this.map.setCenter({ lat: 51.2141191, lng: 3.0517553 })
      // this.map.setZoom(10)
      this.map.fitBounds(this.overviewBounds, 20)
      this.detailView = false
      // eventBus.$emit('detailview', false)
      // this.showAllCities()
    }
  }
}
</script>
